import React from"react";
import FlipCard from"./FlipCard";
import { useNavigate } from"react-router-dom";
import SidebarMenu from"../BasicComponents/SidebarMenu";
import { useSidebar } from "../Context/SidebarContext";
import { SparklesIcon } from "@heroicons/react/24/outline";

const FlipCardList = () => {
 const navigate = useNavigate();
 const { expanded, hoveredLabel } = useSidebar();

 const cards = [
 {
 title:"Jessica Jenner",
 image:"/flip1.jpg",
 description:
"Jessica is the top model in the world. On July 29th she went missing all of a sudden. Do you think you can find her?",
 },
 {
 title:"John Coder",
 image:"/flip2.jpg",
 description:
"You are a detective. John Coder is a famous software engineer who has been murdered. Can you solve the mystery?",
 },
 {
 title:"Haunted Hallway",
 image:"/flip3.jpg",
 description:
"It's 2AM in the morning. When you opened your eyes, you found yourself in a haunted hallway. You are trapped! Can you escape?",
 }
 ];

 return (
 <div className="flex min-h-screen bg-bgMain text-body">
   {/* Sidebar placeholder */}
   <aside className="hidden md:block shrink-0 z-30">
     <SidebarMenu />
   </aside>
   
   <div className={`flex-1 flex items-center justify-center ${expanded ? "md:ml-64" : "md:ml-20"} transition-all duration-300 px-4 relative`}>
     {/* Hover Label Indicator */}
     {!expanded && hoveredLabel && (
       <div 
         className="fixed bg-white/90 backdrop-blur-md px-4 py-2 rounded-xl shadow-lg border border-purple-100 animate-slide-right flex items-center gap-2 z-[9999] pointer-events-none"
         style={{ 
           top: `${hoveredLabel.top}px`, 
           left: '88px',
           transform: 'translateY(-50%)' 
         }}
       >
         <SparklesIcon className="h-4 w-4 text-[#5B21B6] animate-pulse" />
         <span className="text-sm font-black text-[#5B21B6] uppercase tracking-widest whitespace-nowrap">
           {hoveredLabel.text}
         </span>
       </div>
     )}
     
 {/* Back Button */}
 <div className="absolute top-6 left-6 z-10">
 <button
 onClick={() => navigate(-1)}
 className="px-4 py-2 bg-secondary text-black font-semibold rounded hover:bg-primary transition"
 >
 ← Back
 </button>
 </div>

 {/* Flip Cards */}
 <div className="flipcard-container flex flex-wrap gap-6 justify-center">
 {cards.map((card, index) => (
 <FlipCard
 key={index}
 title={card.title}
 subtitle={card.subtitle}
 image={card.image}
 description={card.description}
 />
 ))}
 </div>
 </div>
 </div>
 );
};

export default FlipCardList;


